/**
 * Block: Winner Awards Accordions
 *
 * Minimal JavaScript functionality - detailed implementation to be added later
 */

(function($) {
	'use strict';

	// Winner Awards Accordions Block Handler
	const WinnerAwardsAccordions = {

		/**
		 * Initialize the block functionality
		 */
		init: function() {
			this.bindEvents();
			this.initPagination();
		},

		/**
		 * Bind event handlers
		 */
		bindEvents: function() {
			// Expand/Collapse functionality
			$(document).on('click', '.winner-awards-accordions__accordion-control', this.accordionControl);

			// Pagination functionality
			$(document).on('click', '.pagination__page-first-link', this.handlePagination);
			$(document).on('click', '.pagination__page-previous-link', this.handlePagination);
			$(document).on('click', '.pagination__page-next-link', this.handlePagination);
			$(document).on('click', '.pagination__page-last-link', this.handlePagination);
			$(document).on('click', '.pagination__page-number-link', this.handlePagination);
		},

		/**
		 * Expand/Collapse all winner content
		 */
		accordionControl: function(e) {
			e.preventDefault();
			e.stopPropagation();

			const $this = $(this);
			let $accordionItems = $this.parents('.winner-awards-accordions__inner').find('.accordion-basic--group');

			if ($this.attr('aria-expanded') === 'true') {
				$accordionItems.each(function() {
					if ($(this).hasClass('active') ) {
						$(this).find('.accordion-basic--expander').trigger('click');
		 			}
				});

				$this
					.attr('aria-expanded', 'false')
					.find('label').html('Expand All');
			}
			else {
				$accordionItems.each(function() {
					if (!$(this).hasClass('active') ) {
						$(this).find('.accordion-basic--expander').trigger('click');
		 			}
				});

				$this
					.attr('aria-expanded', 'true')
					.find('label').html('Close All');
			}
		},

		/**
		 * Handle pagination clicks
		 */
		handlePagination: function(e) {
			e.preventDefault();
			const $button = $(this);
			const $block = $button.closest('.winner-awards-accordions');
			const $pagination = $button.closest('.pagination__nav');

			// Don't proceed if button is disabled
			if ($button.closest('li').hasClass('--disabled')) {
				return;
			}

			let targetPage = 1;
			const currentPage = parseInt($pagination.find('.pagination__page-number.--current .pagination__page-number-link').text()) || 1;

			// Determine target page based on button type
			if ($button.hasClass('pagination__page-first-link')) {
				targetPage = 1;
			} else if ($button.hasClass('pagination__page-previous-link')) {
				targetPage = Math.max(1, currentPage - 1);
			} else if ($button.hasClass('pagination__page-next-link')) {
				const totalPages = WinnerAwardsAccordions.getTotalPages($block);
				targetPage = Math.min(totalPages, currentPage + 1);
			} else if ($button.hasClass('pagination__page-last-link')) {
				targetPage = WinnerAwardsAccordions.getTotalPages($block);
			} else if ($button.hasClass('pagination__page-number-link')) {
				targetPage = parseInt($button.text());
			}

			WinnerAwardsAccordions.goToPage($block, targetPage);
		},

		/**
		 * Go to specific page
		 */
		goToPage: function($block, pageNumber) {
			const itemsPerPage = parseInt($block.find('.winner-awards-accordions__winners-list').data('winners-paged')) || 10;
			const $items = $block.find('.winner-awards-accordions__winner-item');

			// Hide all items
			$items.addClass('--hidden');

			// Show items for current page
			const startIndex = (pageNumber - 1) * itemsPerPage;
			const endIndex = startIndex + itemsPerPage;

			$items.slice(startIndex, endIndex).removeClass('--hidden');

			// Update pagination
			WinnerAwardsAccordions.updatePagination($block, pageNumber);

			// Scroll to top of block only if we're not on first page
			if (pageNumber > 1) {
				const blockTop = $block.offset().top - 100;
				$('html, body').animate({
					scrollTop: blockTop
				}, 300);
			}
		},

		/**
		 * Update pagination display
		 */
		updatePagination: function($block, currentPage) {
			const $pagination = $block.find('.pagination__nav');
			const totalPages = WinnerAwardsAccordions.getTotalPages($block);

			// Update current page indicator
			$pagination.find('.pagination__page-number').removeClass('--current');
			$pagination.find('.pagination__page-number').each(function() {
				const pageNum = parseInt($(this).find('.pagination__page-number-link').text());
				if (pageNum === currentPage) {
					$(this).addClass('--current');
					// Change link to span for current page
					const $link = $(this).find('.pagination__page-number-link');
					const linkText = $link.text();
					const linkTitle = $link.attr('title');
					$(this).html(`<span class="pagination__page-number-link" title="Current ${linkTitle}">${linkText}</span>`);
				} else {
					// Change span back to link for non-current pages
					const $span = $(this).find('.pagination__page-number-link');
					if ($span.is('span')) {
						const spanText = $span.text();
						$(this).html(`<a href="#" class="pagination__page-number-link" title="Page ${spanText}">${spanText}</a>`);
					}
				}
			});

			// Update first/previous buttons
			$pagination.find('.pagination__page-first, .pagination__page-previous').removeClass('--disabled');
			if (currentPage === 1) {
				$pagination.find('.pagination__page-first, .pagination__page-previous').addClass('--disabled');
			}

			// Update next/last buttons
			$pagination.find('.pagination__page-next, .pagination__page-last').removeClass('--disabled');
			if (currentPage === totalPages) {
				$pagination.find('.pagination__page-next, .pagination__page-last').addClass('--disabled');
			}
		},

		/**
		 * Get total number of pages
		 */
		getTotalPages: function($block) {
			const itemsPerPage = parseInt($block.find('.winner-awards-accordions__winners-list').data('winners-paged')) || 10;
			const totalItems = $block.find('.winner-awards-accordions__winner-item').length;
			return Math.ceil(totalItems / itemsPerPage);
		},

		/**
		 * Initialize pagination
		 */
		initPagination: function() {
			$('.winner-awards-accordions').each(function() {
				const $block = $(this);
				WinnerAwardsAccordions.goToPage($block, 1);
			});
		}
	};

	// Initialize when document is ready
	$(document).ready(function() {
		WinnerAwardsAccordions.init();
	});

})(jQuery);
